import { isEmpty } from 'lodash-es';
import { useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext';
import { useInventoryEventDetailContext } from 'src/contexts/InventoryEventDetailContext/InventoryEventDetailContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { InfoOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { AutoPricingInputs, Feature } from 'src/WebApiController';

import * as styles from './CompSelectedSectionsRecommendations.css';

export const CompSelectedSectionRecommendations = () => {
  const { isRecommendationDeclined } = useInventoryEventDetailContext();

  const hasSelectedSectionScoreRecommendationsFeature = useUserHasFeature(
    Feature.SelectedSectionScoreRecommendations
  );

  const { watch } = useFormContext<AutoPricingInputs>();

  const { compListingSelectedSectionSettings } = watch();

  if (!hasSelectedSectionScoreRecommendationsFeature) {
    return null;
  }

  if (
    isRecommendationDeclined &&
    isEmpty(compListingSelectedSectionSettings?.sectionIdFilter)
  ) {
    return (
      <Stack
        width="full"
        gap="s"
        alignItems="center"
        className={styles.recommendationContainer}
      >
        <InfoOutlineIcon size={vars.iconSize.m} />
        <Content id={ContentId.ComparingAgainstAllSections} />
      </Stack>
    );
  }
  return null;
};
